import { IUserRoles, IWork, IWorkStatus } from 'models';
import { userStore } from 'stores';
import { formatPhoneNumber } from 'utils';
import { getWorkNumber } from 'utils/get-work-number';
import { getZipLocation } from 'utils/zip';

interface WorkTitleProps {
	work: IWork
}

export const WorkTitle = ({ work }: WorkTitleProps) => {
	const { acf: { foreman_info, customer_info }, author } = work;
	const workers = foreman_info?.workers || [];
	const foreman = workers?.find((el) => el?.worker_role === IUserRoles.FOREMAN);
	const foremanName = userStore.getUser(Number(foreman?.worker))?.name;
	const isConfirmed = foreman_info?.status === IWorkStatus.CONFIRMED ? '❗️' : '';

	return (
		<span>
			{isConfirmed}
			{foremanName && <><span className="foreman-name-title">{foremanName}</span> - </>}
			{getWorkNumber(work)}
			{' '}
			{customer_info.movers ? `-${parseInt(customer_info.movers)}-` : ''}
			{' '}
			{customer_info.customer_name}
			{' '}
			{formatPhoneNumber(customer_info.customer_phone)} | {customer_info.howfrom || ''} | {userStore.getUser(author)?.name} | {getZipLocation(customer_info?.pickup_address?.[0]?.zip)}
		</span>
	);
};